import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const SportsRegister = lazyRouteComponent(() => import('../pages/sports-register'))

export const sportsRegister = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sports-register',
  component: SportsRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
